import React from "react";
import { Link } from "react-router-dom";

const groups = [
  { title: "EXPLORE", links: [["Start Here", "/start-here"], ["Ideas", "/ideas"], ["Principles", "/principles"], ["Books", "/books"], ["Resources", "/resources"]] },
  { title: "TOPICS", links: [["Mindset", "/ideas/mindset"], ["Discipline", "/ideas/discipline"], ["Leadership", "/ideas/leadership"], ["Resilience", "/ideas/resilience"], ["Relationships", "/ideas/relationships"], ["Intentional Living", "/ideas/intentional-living"]] },
  { title: "LEARN", links: [["Books", "/books"], ["Programs", "/programs"], ["Workshops", "/programs"], ["Speaking", "/contact"]] },
  { title: "IMPACTFUL MINDSET 101", links: [["About", "/about"], ["Join", "/join"], ["Contact", "/contact"], ["Privacy", "/privacy"], ["Terms", "/terms"]] },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0A1D3D] text-slate-300 mt-28">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-16">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <div className="font-serif-display text-2xl font-bold text-white leading-tight">
              IMPACTFUL <span className="text-[#C9A25A]">MINDSET</span> <span className="text-slate-200">101</span>
            </div>
            <p className="text-sm text-slate-400 mt-5 max-w-xs leading-relaxed">
              A publishing and ideas platform for practical thinking, personal growth, leadership, discipline, resilience and intentional living.
            </p>
            <div className="gold-rule mt-6" />
          </div>
          <div className="md:col-span-8 grid grid-cols-2 md:grid-cols-4 gap-8">
            {groups.map((g) => (
              <div key={g.title}>
                <h4 className="text-[0.7rem] tracking-[0.2em] font-semibold text-white/60 mb-4">{g.title}</h4>
                <ul className="space-y-2.5">
                  {g.links.map(([label, to]) => (
                    <li key={label + to}>
                      <Link to={to} className="text-sm text-slate-300 hover:text-[#C9A25A] transition-colors">{label}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-slate-400">© {new Date().getFullYear()} Impactful Mindset 101. All rights reserved.</p>
          <p className="text-xs text-slate-500 italic font-serif-display">Better thinking. Better decisions. A more intentional life.</p>
        </div>
      </div>
    </footer>
  );
}
